/* Pulsebeet buy box: pack/plan selection -> hidden inputs + price, gallery, quantity.
   No external libraries. Dawn's <product-form> handles the actual add-to-cart. */
(function () {
  class PbProduct extends HTMLElement {
    connectedCallback() {
      this.idInput = this.querySelector('.product-variant-id');
      this.planInput = this.querySelector('.pb-selling-plan');
      this.submitBtn = this.querySelector('.pb-buybox__submit');

      this.addEventListener('change', (e) => {
        if (e.target.matches('.pb-plan__radio')) this.sync();
      });
      this.addEventListener('click', (e) => {
        const thumb = e.target.closest('.pb-thumbs__btn');
        if (thumb) this.swapImage(thumb);
        const qty = e.target.closest('[data-qty]');
        if (qty) this.step(qty.getAttribute('data-qty'));
        const qset = e.target.closest('[data-qty-set]');
        if (qset) this.setQty(qset);
        const bo = e.target.closest('[data-buyonce]');
        if (bo) {
          const isOne = this.classList.toggle('is-onetime');
          bo.textContent = isOne ? 'Subscribe · Save more →' : 'Buy once · No savings →';
          this.sync();
        }
      });

      this.sync();
    }

    sync() {
      // Each card = one variant (supply bundle). is-onetime is an independent mode:
      // one-time drops the selling plan and shows regular prices, the card stays selected.
      const card = this.querySelector('.pb-plan__radio:checked');
      const isOne = this.classList.contains('is-onetime');

      if (this.idInput && card) {
        this.idInput.value = card.dataset.variantId || '';
        this.idInput.disabled = false;
      }
      if (this.planInput) this.planInput.value = isOne ? '' : (card ? card.dataset.planId || '' : '');

      this.querySelectorAll('.pb-plan').forEach((l) => {
        const r = l.querySelector('.pb-plan__radio');
        l.classList.toggle('is-selected', !!r && r.checked);
      });

      // Quantity multiplies the chosen supply (people). Bottles are baked into the variant.
      const people = parseInt(this._people || '1', 10) || 1;
      const qtyInput = this.querySelector('.pb-qty__input');
      if (qtyInput) qtyInput.value = people;
    }

    swapImage(btn) {
      const main = this.querySelector('.pb-product__main-img');
      if (!main) return;
      if (btn.dataset.mediaSrc) main.src = btn.dataset.mediaSrc;
      if (btn.dataset.mediaSrcset) main.srcset = btn.dataset.mediaSrcset;
      this.querySelectorAll('.pb-thumbs__btn').forEach((b) => b.classList.toggle('is-active', b === btn));
    }

    step(dir) {
      const input = this.querySelector('.pb-qty__input');
      if (!input) return;
      const min = parseInt(input.min, 10) || 1;
      let v = parseInt(input.value, 10) || min;
      v = dir === 'plus' ? v + 1 : Math.max(min, v - 1);
      input.value = v;
    }

    setQty(btn) {
      this._people = btn.getAttribute('data-qty-set');
      this.querySelectorAll('.pb-qtytoggle__btn').forEach((b) => b.classList.toggle('is-active', b === btn));
      this.sync();
    }
  }

  if (!customElements.get('pb-product')) customElements.define('pb-product', PbProduct);
})();
